import React from 'react';
import {
    Box,
    Typography,
    Divider,
    Grid,
    Stack,
    Paper,
    Chip,
    useTheme
} from '@mui/material';
import {
    KingBed,
    Bathtub,
    LocalParking,
    Home,
    DirectionsBike,
    CalendarToday,
    Opacity,
    Balcony,
    Power,
    SquareFoot,
    Layers,
    Security,
    Chair,
    AcUnit,
    Wifi,
    LocalLaundryService
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
 
const YourIndividualVillaOverview = ({ propertyData }) => {
    const theme = useSelector((data) => data.themeValue.colors);
 
    // Default property data
    const defaultProperty = {
        ExtraData: {
            LandAreaInSqFt: "2500",
            ParkingAvailable: "Yes",
            ParkingType: "Covered",
            AgeOfBuilding: "5 years",
            Type: "Independent House/Villa"
        }
    };
    if (!propertyData?.length) {
        return <Typography sx={{ p: 2 }}>No property overview data available.</Typography>;
    }
 
    const villa = propertyData[0];
    let extra = villa.ExtraData || {};
 
    if (typeof extra === 'string') {
        try {
            extra = JSON.parse(extra);
        } catch (e) {
            console.error("Failed to parse ExtraData JSON:", e);
            extra = {};
        }
    }
 
    const propertyDetails = [
        { icon: <SquareFoot color="primary" sx={{ color: theme.normal_icon }} />, label: "Land Area In SQFT", value: extra.LandAreaInSqFt || "NA" },
        { icon: <CalendarToday color="primary" sx={{ color: theme.normal_icon }} />, label: "Age of Building", value: extra.AgeOfBuilding || "NA" },
        { icon: <LocalParking color="primary" sx={{ color: theme.normal_icon }} />, label: "Parking Type", value: extra.ParkingType || "NA" },
        { icon: <Layers color="primary" sx={{ color: theme.normal_icon }} />, label: "Parking Available", value: extra.ParkingAvailable || "NA" },
 
 
 
    ];
 
    return (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 1, sm: 3 },
                borderRadius: 3,
                border: '1px solid',
                // borderColor: theme.background,
                height: 'auto',
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                backgroundColor: theme.background,
                marginBottom: 4,
                marginRight: 2,
                marginLeft: 2
            }}
        >
            {/* Property Overview Section */}
            <Box>
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 700,
                        color: theme.text,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        mb: 1
                    }}
                >
                    Your Property Overview
                </Typography>
                <Divider sx={{ mb: 2, backgroundColor: theme.secondary_text_color }} />
 
                <Grid container spacing={2} sx={{
                    display: "flex", justifyContent: "start",
                    flexWrap: "wrap",
                    textAlign: "center",
                    width: "100%",
                    // backgroundColor: "blue"
                }}>
                    {propertyDetails.map((item, index) => (
                        <Grid key={index} sx={{
                            width: { xs: "auto", sm: "30%" },
                            display: "flex",
                            justifyContent: "space-between",
                            // backgroundColor: "red"
                        }}>
                            <Box
                                elevation={0}
                                sx={{
                                    // width: {
                                    //     xs: '8rem',     // Extra-small devices (mobile)
                                    //     sm: '16rem',    // Small devices (tablet)
                                    //     md: '23rem',    // Medium devices (laptop)
                                    //     lg: '22rem',    // Large devices
                                    // },
                                    width: "100%",
                                    p: 1.5,
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    borderBottom: '1px dotted',
                                    borderColor: theme.borderColor,
                                    transition: 'all 0.3s ease',
 
                                }}
                            >
                                <Box
                                    sx={{
                                        // p: 1,
                                        color: theme.text,
                                        borderRadius: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    {item.icon}
                                </Box>
                                <Box sx={{ display: { xs: "null", sm: "flex", }, gap: 1 }}>
 
                                    <Typography
                                        variant="caption"
 
                                        sx={{ color: theme.text, }}
                                    >
                                        {item.label}
                                    </Typography>
                                    <Typography
                                        variant="subtitle2"
                                        fontWeight={600}
                                        sx={{ lineHeight: 1.2, color: theme.text, }}
                                    >
                                        {item.value}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Paper>
    );
};
 
export default YourIndividualVillaOverview;